import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {baseUrl} from "../../../../../../../core/constants/base-url";
import {
  CompetitorArticleDta,
  SyncCompetitorArticleProductCard,
  SyncCompetitorArticleQueryParams
} from "../types/competitor-article-sync.types";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CompetitorArticleSyncApiService {
  private http: HttpClient = inject(HttpClient);
  private url: string = `${baseUrl}/product-cards`;

  public fetchCompetitorArticlesList(params: SyncCompetitorArticleQueryParams): Observable<Array<CompetitorArticleDta>> {
    return this.http.get<Array<CompetitorArticleDta>>(`${this.url}/unlinked-competitor-articles`, { params: params });
  }

  public fetchSyncCompetitorArticlesList(params: SyncCompetitorArticleQueryParams): Observable<Array<CompetitorArticleDta>> {
    return this.http.get<Array<CompetitorArticleDta>>(`${this.url}/linked-competitor-articles`, { params: params });
  }

  public attachCompetitorArticle({ productCardId, articles }: SyncCompetitorArticleProductCard): Observable<void> {
    return this.http.post<void>(`${this.url}/link-competitor-articles`, articles, { params: { productCardId } });
  }

  public detachCompetitorArticle({ productCardId, articles }: SyncCompetitorArticleProductCard): Observable<void> {
    return this.http.delete<void>(`${this.url}/unlink-competitor-articles`, { body: articles, params: { productCardId } });
  }
}
